export const production =
  require('../../package.json').deployment.properties['production-us-east-1']
    .env
export const internal =
  require('../../package.json').deployment.properties['production-us-east-1'][
    'internal-env'
  ]
export const external =
  require('../../package.json').deployment.properties['production-us-east-1'][
    'external-env'
  ]
